export default "/pl/katalog/@slug";
